import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

export default function FeaturedProducts() {
  const featured = products.filter((p) => p.isHot || p.isNew).slice(0, 8);

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-secondary-500 tracking-[0.2em] uppercase mb-2">
            Featured Selection
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto">
            专业团队为您精心甄选，每一款都经过严格品质把关
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {featured.map((product) => (
            <Link
              key={product.id}
              to={`/category`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-square rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={product.image}
                  alt={product.name}
                  title={`${product.name} - 成人精品推荐`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {product.badge && (
                  <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-label font-medium rounded-full bg-primary-500 text-background-50">
                    {product.badge}
                  </span>
                )}
                {product.originalPrice && (
                  <span className="absolute top-2 right-2 px-2 py-0.5 text-[10px] font-label rounded-full bg-background-50/90 text-primary-700">
                    省¥{product.originalPrice - product.price}
                  </span>
                )}
              </div>
              <h3 className="text-sm font-label font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {product.name}
              </h3>
              <div className="flex items-center gap-1 mt-1">
                <i className="ri-star-fill text-[10px] text-accent-500" />
                <span className="text-xs text-foreground-600">{product.rating}</span>
                <span className="text-xs text-foreground-400">({product.reviewCount})</span>
              </div>
              <div className="flex items-center gap-2 mt-1.5">
                <span className="text-base font-heading font-semibold text-primary-600">
                  ¥{product.price}
                </span>
                {product.originalPrice && (
                  <span className="text-xs text-foreground-400 line-through">
                    ¥{product.originalPrice}
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-label font-medium whitespace-nowrap rounded-full border border-secondary-300 text-foreground-700 hover:bg-secondary-50 transition-colors cursor-pointer"
          >
            查看全部精品
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}